<template>
  <!-- Figma D1 row: "Service" select (423px, r10) · Select Parts (130x40 #7695FF) · Labor Warranty checkbox; hint below.
       Below laptop (Figma mobile 5908-2374): Labor Warranty left, Select Parts right.
       Mutates item fields like the old markup did (selected_service, is_service_warranty). -->
  <div class="font-roboto">
    <label v-if="showSelect" class="block mt-0 mb-[5px] text-[14px] leading-none text-[#666666]">Service</label>
    <div class="flex flex-wrap items-center gap-[15px]">
      <FxSelect v-if="showSelect" v-model="item.selected_service" :options="actions" label-key="new_display_name"
        value-key="object" placeholder="Select Service" wrapper-class="tablet:!w-[423px]"
        :button-class="item.is_error ? '!border-[#EE5851]' : ''" @change="$emit('service-change', item)" />
        
      <button type="button"
        class="mobile:order-2 laptop:order-none mobile:ml-auto laptop:ml-0 w-[130px] h-[40px] rounded-[10px] border-1 text-[14px] font-medium disabled:bg-[#EEF0F4] disabled:border-[#EEF0F4] disabled:text-[#A8AEB8] bg-[#7695FF] border-[#7695FF] text-white"
        :disabled="partsDisabled" @click="$emit('select-part')">
        Select Parts
      </button>
      <label v-if="showWarranty" class="mobile:order-1 laptop:order-none flex items-center gap-[8px] m-0 cursor-pointer select-none mobile:text-[12px] laptop:text-[14px] text-[#666666]">
        <input v-model="item.is_service_warranty" type="checkbox" class="sr-only" @change="$emit('warranty-change', item)">
        <span class="mobile:w-[16px] mobile:h-[16px] laptop:w-[20px] laptop:h-[20px] rounded-[3px] border-1 bg-white flex items-center justify-center"
          :class="item.is_service_warranty ? 'border-[#7695FF]' : 'border-[#CCCCCC]'">
          <svg v-if="item.is_service_warranty" width="11" height="11" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7.4l2.6 2.5L11 4.4" stroke="#7695FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </span>
        Labor Warranty
      </label>
    </div>
    <small v-if="item.is_error" class="block mt-[6px] text-[11px] laptop:text-[12px] font-medium text-[#EE5851]">{{ item.error }}</small>
    <p v-else-if="showSelect && !item.selected_service" class="flex items-center gap-[6px] mb-0 mobile:mt-[12px] laptop:mt-[10px] mobile:text-[11px] laptop:text-[12px] leading-[17px] text-[#8A9099]">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="flex-shrink-0"><circle cx="12" cy="12" r="9" stroke="#8A9099" stroke-width="2" /><path d="M12 11v5M12 8h.01" stroke="#8A9099" stroke-width="2" stroke-linecap="round" /></svg>
      Choose a service first to unlock parts for this component.
    </p>
  </div>
</template>

<script>
import FxSelect from "../partialComponent/FxSelect.vue";

export default {
  components: { FxSelect },
  props: {
    item: { type: Object, required: true },
    // booking actions for this item's value (required / recommended)
    actions: { type: Array, default: () => [] },
    showSelect: { type: Boolean, default: true },
    showWarranty: { type: Boolean, default: true },
    partsDisabled: { type: Boolean, default: false },
  },
  emits: ['service-change', 'select-part', 'warranty-change'],
};
</script>
